import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiX } from "react-icons/fi";

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
`;

const Modal = styled(motion.div)`
  background: white;
  border-radius: 20px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Header = styled.div`
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  color: #2d3436;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    color: #495057;
  }
`;

const Content = styled.div`
  padding: 2rem;
  text-align: center;
`;

const Icon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  color: white;
  font-size: 2rem;
`;

const Message = styled.p`
  color: #6c757d;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const Button = styled.button`
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &.primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;

          &:hover {
            transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
    }
          }

  &.secondary {
          background: #f8f9fa;
    color: #6c757d;
    border: 1px solid #dee2e6;

          &:hover {
            background: #e9ecef;
      color: #495057;
    }
  }
`;

const CreateSubscriptionModal = ({ onClose, onSuccess }) => {
  const navigate = useNavigate();

  const handleRedirectToMealPlans = () => {
    onClose(); // Close the modal first
    navigate("/meal-plans"); // Navigate to meal plans page
  };

  return (
      <Overlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <Modal
        initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <Header>
            <Title>Create New Subscription</Title>
          <CloseButton onClick={onClose}>
            <FiX />
          </CloseButton>
          </Header>

          <Content>
          <Icon>
            <FiArrowRight />
          </Icon>

          <Message>
            To create a new subscription, please browse our available meal plans
            and select the one that best fits your needs. You'll be able to
            customize your subscription options during checkout.
          </Message>

              <ButtonGroup>
            <Button className="secondary" onClick={onClose}>
              Cancel
                  </Button>
            <Button className="primary" onClick={handleRedirectToMealPlans}>
              Browse Meal Plans
              <FiArrowRight />
                  </Button>
              </ButtonGroup>
          </Content>
        </Modal>
      </Overlay>
  );
};

export default CreateSubscriptionModal;
